/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetFavoriteRequest } from '../../models/set-favorite-request';

export interface DashboardFavoritesDashboardIdOrganizationPost$Params {
  dashboardId: string;
      body?: SetFavoriteRequest
}

export function dashboardFavoritesDashboardIdOrganizationPost(http: HttpClient, rootUrl: string, params: DashboardFavoritesDashboardIdOrganizationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dashboardFavoritesDashboardIdOrganizationPost.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

dashboardFavoritesDashboardIdOrganizationPost.PATH = '/dashboard-favorites/{dashboardId}/organization';
